import { shade } from "polished"

const adventureChinaRed = "#bd2126"
const deepRed = "#7D161A"
const brightGold = "#FBEDCA"
const gold = "#F7DA94"
const lightGrey = "#F8F8F8"
const midLightGrey = "rgb(158, 158, 158)"
const midGrey = "rgb(102, 102, 102)"
const darkGrey = "#221F20"
const white = "#FFFFFF"
const green = "#99CC00"
const bookedGreen = "#98cc00"
const inputFieldGrey = "#F6F6F6"
const inputFieldBlack = "#515151"
const inputFieldBorder = "#CCCCCC"
const inputFieldHint = "#999999"

const adventurechina = {
  name: "Adventure China",
  colors: {
    brand: adventureChinaRed,
    brand2: deepRed,
    body: white,
    background: white,
    primary: adventureChinaRed,
    secondary: deepRed,
    success: gold,
    warning: gold,
    danger: adventureChinaRed,
    lightGrey: lightGrey,
    midLightGrey: midLightGrey,
    midGrey: midGrey,
    darkGrey: darkGrey,
    primaryContrasted: shade(0.2, adventureChinaRed),
    primaryContrastedDarker: shade(0.3, adventureChinaRed),
    notifications: {
      meta: gold,
      badge: {
        background: gold,
        text: white
      }
    },
    profile: {
      headerBg: adventureChinaRed,
      avatarBackground: deepRed,
      buttons: {
        primary: {
          background: gold,
          text: darkGrey
        },
        secondary: {
          background: white,
          text: white
        }
      },
      badge: {
        background: "#f2c400",
        text: "#004252"
      }
    },
    statuses: {
      locked: deepRed,
      incomplete: darkGrey,
      complete: green,
      started: brightGold,
      rejected: adventureChinaRed
    },
    home: {
      headings: deepRed
    },
    feature: {
      background: "#fab70040",
      text: "#004152"
    },
    banner: {
      background: "#02ADE51A",
      text: "#004152"
    },
    content: {
      background: lightGrey,
      text: darkGrey,
      url: adventureChinaRed
    },
    contactInfo: {
      background: lightGrey,
      title: deepRed,
      text: adventureChinaRed
    },
    applicationProgress: {
      bar: "#DDD",
      value: adventureChinaRed
    },
    tables: {
      headings: gold
    },
    buttons: {
      lightColor: white,
      darkColor: darkGrey,
      special: {
        main: brightGold,
        text: darkGrey
      },
      search: {
        textColor: darkGrey
      }
    },
    incompletion: {
      lightenAmount: 0.2,
      background: gold
    },
    availability: {
      booked: bookedGreen
    },
    fields: {
      text: inputFieldBlack,
      contentText: inputFieldBlack,
      contentHeading: "#666666",
      label: "#333333",
      border: inputFieldBorder,
      backgroundColor: inputFieldGrey,
      hint: inputFieldHint,
      fieldsetText: "#717171",
      backButton: "#CCCCCC",
      backButtonText: "#666666",
      invalid: {
        darkenAmount: 0.3
      },
      spacer: "#F2F2F2"
    },
    conversations: {
      activeChat: "rgba(2, 173, 229, 0.1)"
    },
    alerts: {
      info: "#004152",
      danger: "#FF2230",
      success: "#8FCB24"
    },
    headerGradient: {
      start: adventureChinaRed,
      end: "#eb3d44"
    }
  },
  fonts: {
    body: {
      family: "Helvetica Neue",
      weight: "400"
    },
    headings: {
      family: "Helvetica Neue",
      weight: "700"
    }
  },
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
}

export default adventurechina
